import _extends from "@babel/runtime/helpers/extends";
import { Box, FormField, ToggleSwitch } from '@wix/design-system';
import React from 'react';
import { RuleListStatus } from '../../../types';
import { dataHooks } from '../../../utils/datahooks';
import { RuleFooter, RuleLayout } from '../../rule-layout';
import { ToggleFixerCompletedState } from './toggle-rule-completed-state';
import { useToggleFixer } from './use-toggle-fixer';
export const ToggleRuleFixer = _ref => {
  var _ruleFooterProps$subm;
  let {
    ruleResult
  } = _ref;
  const {
    checkedValue,
    toggleLabel,
    ruleFooterProps,
    description,
    onChange,
    tips,
    isEditMode,
    onEditClick
  } = useToggleFixer(ruleResult);
  const design = ruleResult.fixerProps.design;
  return ruleResult.status === RuleListStatus.passed && !isEditMode ? /*#__PURE__*/React.createElement(ToggleFixerCompletedState, {
    description: description,
    ruleResult: ruleResult,
    onEditClick: onEditClick
  }, ruleResult.fixerProps.completedRuleContent.children) : /*#__PURE__*/React.createElement(RuleLayout, {
    description: description,
    design: design == null ? void 0 : design.ruleLayout
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: (design == null ? void 0 : design.formGap) ?? 'SP1'
  }, /*#__PURE__*/React.createElement(FormField, {
    label: toggleLabel,
    labelPlacement: "right",
    stretchContent: false
  }, /*#__PURE__*/React.createElement(ToggleSwitch, {
    checked: checkedValue,
    dataHook: dataHooks.toggleFieldToggleFixer(ruleResult.dataHook),
    disabled: (_ruleFooterProps$subm = ruleFooterProps.submitButtonProps) == null ? void 0 : _ruleFooterProps$subm.showLoader,
    size: "small",
    onChange: () => onChange(!checkedValue)
  })), tips), /*#__PURE__*/React.createElement(RuleFooter, _extends({}, ruleFooterProps, {
    design: design == null ? void 0 : design.ruleFooter
  })));
};
//# sourceMappingURL=toggle-rule-fixer.js.map